import { Link } from "react-router-dom";
import { category } from "../../components/utility/category";
import "./category-menu.css";
import { getImageSourceFromGithub } from "../services/common-services";

export default function CategoryMenu() {
    return (
        <>
            {category.map((categoryItem) => (
                <div key={categoryItem.id} className="category-section">
                    <p className="category-head">{categoryItem.name}</p>

                    <div className="category-container">
                        {categoryItem.data.map((subCategory) => (
                            <Link
                                key={subCategory.id}
                                to="/display-products-category"
                                state={{ categoryData: subCategory, name: subCategory.name }}
                                className="category-box"
                            >
                                <div className="icon-wrapper">
                                    <img
                                        src={getImageSourceFromGithub(`category-image/${subCategory.id}.png`).uri}
                                        alt={subCategory.name}
                                        className="category-image"
                                        loading="lazy"
                                    />
                                </div>

                                <p className="category-text">{subCategory.name}</p>
                            </Link>
                        ))}
                    </div>
                </div>
            ))}
        </>
    );
}
